import { useId } from 'react';

/**
 * AIMS OS logo — renders the official SVG mark.
 *
 * @param {object}  props
 * @param {number}  [props.size=24]      - Height in pixels (width scales proportionally)
 * @param {string}  [props.className]    - Additional CSS classes
 * @param {boolean} [props.withText]     - Show "AIMS OS" text next to the mark
 * @param {string}  [props.textClassName] - CSS classes for the text
 */
const AimsLogo = ({ size = 24, className = '', withText = false, textClassName = '' }) => {
  const gradId = useId();

  return (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <svg
      viewBox="400 300 800 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      style={{ width: 'auto' }}
    >
      <defs>
        <linearGradient
          id={gradId}
          x1="999"
          y1="471.5"
          x2="729.9"
          y2="932"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#09E2AB" />
          <stop offset="1" stopColor="#1B72FF" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradId})`}
        d="M1120.01,802.69L880.38,387.64c-16.78-29.06-46.83-46.41-80.38-46.41c-33.55,0-63.6,17.35-80.38,46.41
        L479.99,802.69c-4.22,7.31-4.22,16.32,0,23.64c4.22,7.31,12.03,11.82,20.47,11.82h119.81c8.45,0,16.25-4.51,20.47-11.82
        l99.34-172.07l78.87,136.61h-41.78c-7.86-12.37-21.64-20.62-37.35-20.62c-24.4,0-44.25,19.85-44.25,44.25s19.85,44.25,44.25,44.25
        c15.71,0,29.49-8.25,37.35-20.62h82.72c8.45,0,16.25-4.51,20.47-11.82c4.22-7.31,4.22-16.32,0-23.64L760.56,595.17
        c-4.22-7.31-12.03-11.82-20.47-11.82c-8.45,0-16.25,4.51-20.47,11.82l-112.99,195.7h-65.22l219.16-379.59
        c8.23-14.26,22.97-22.77,39.43-22.77c16.46,0,31.2,8.51,39.43,22.77l219.16,379.59h-65.22l-154.21-267.1
        c3.24-6.15,5.09-13.13,5.09-20.55c0-24.4-19.85-44.25-44.25-44.25s-44.25,19.85-44.25,44.25c0,23.79,18.89,43.21,42.46,44.16
        l161.05,278.94c4.22,7.31,12.03,11.82,20.47,11.82h119.81c8.45,0,16.25-4.51,20.47-11.82
        C1124.23,819.02,1124.23,810.01,1120.01,802.69z"
      />
    </svg>
    {withText && <span className={`font-bold tracking-tight ${textClassName}`}>AIMS OS</span>}
  </span>
  );
};

export default AimsLogo;
